import React, { FC } from 'react';
import FeaturedIcon from '../../../components/shared/FeaturedIcon';
import AlertIcon from '../../../components/icons/AlertIcon';
import { Typo } from '../../../components/Typo';
import { FormattedMessage } from 'react-intl';
import { TRANSLATED_CONSTANTS } from '../../../static/translatedConstants';
import Button from '../../../components/shared/Button';

type Props = {
  onRetry: () => void;
};

// Visible failure state for the marketplace list/map queries (map plan B4).
// Without this, a backend hiccup (the API has 503'd under burst load before)
// rendered exactly like "no listings here" - which quietly teaches visitors
// the marketplace is empty. One manual Retry per click; no auto-retry loops.
const ListingsLoadError: FC<Props> = ({ onRetry }) => {
  return (
    <div className="w-full flex flex-col justify-center items-center py-5 md:py-12 px-3 border border-gray-200 rounded-xl shadow">
      <div className="w-full md:w-[352px] flex flex-col items-center">
        <FeaturedIcon theme="light-circle-outline" color="warning" size="xl" type="icon">
          <AlertIcon className="w-6 h-6 md:h-7 md:w-7 text-yellow-600" />
        </FeaturedIcon>
        <div className="flex flex-col items-center mt-4 md:mt-5">
          <Typo.textXl fontWeight="font-medium" className="text-gray-900 mb-2">
            <FormattedMessage
              id={TRANSLATED_CONSTANTS.LISTINGS_LOAD_FAILED.id}
              defaultMessage={TRANSLATED_CONSTANTS.LISTINGS_LOAD_FAILED.defaultMessage}
            />
          </Typo.textXl>
          <div className="font-inter text-sm leading-5 md:text-base md:leading-6 text-gray-500 text-center">
            <FormattedMessage
              id={TRANSLATED_CONSTANTS.LISTINGS_LOAD_FAILED_NOTE.id}
              defaultMessage={TRANSLATED_CONSTANTS.LISTINGS_LOAD_FAILED_NOTE.defaultMessage}
            />
          </div>
        </div>
        <div className="flex gap-3 mt-6 md:mt-8">
          <Button onClick={onRetry} theme="primary-yellow" size="lg">
            <Typo.textMd fontWeight="font-semibold" className="text-gray-900">
              <FormattedMessage
                id={TRANSLATED_CONSTANTS.RETRY.id}
                defaultMessage={TRANSLATED_CONSTANTS.RETRY.defaultMessage}
              />
            </Typo.textMd>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ListingsLoadError;
